<script>
  import {
    SearchIcon,
  } from 'vue-feather-icons'
  import {
    userMethods,
    statusGetters,
  } from '@state/helpers'
  import {
    doesUserHavePermission,
  } from '@utils/permissions'

  export default {
    components: {
      SearchIcon,
    },
    props: {
      adminPermission: {
        type: null,
        required: true,
      },
      getStatuses: {
        type: null,
        default: null,
      },
      placeholderText:{
        type: String,
        default: null,
      },
      defaultFilters: {
        type: Array,
        default: () => [],
      },
      insideModal:{
        type: Boolean,
        default: false,
      },
      hasExtraFilters:{
        type: Boolean,
        default: false,
      },
      hasExternalStatus:{
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        statuses: [],
        statusesAdmin: [],
        search: '',
        toggleFilters: true,
        boundCollapse: true,
        filtersWatcher: null,
      }
    },
    computed:{
      filters(){
        const partA = this.statuses.map(el => {
          if (el.selected){
            return el.key
          }
        }).filter(el => el)
        const partB = this.statusesAdmin.map(el => {
          if (el.selected){
            return el.key
          }
        }).filter(el => el)
        return [...partA, ...partB]
      },
      searchPlaceholder(){
        if (this.placeholderText){
          return this.placeholderText
        }
        return "Search"
      },
      displayFilters(){
        return this.toggleFilters
      },
    },
    async created() {
      // load options
      await this.loadStatuses()

      if (this.defaultFilters && this.defaultFilters.length > 0){
        this.defaultFilters.forEach(el => {
          const s = this.statuses.find(inner => inner.key === el);
          if (s) s.selected = true
          const sa = this.statusesAdmin.find(inner => inner.key === el);
          if (sa) sa.selected = true
        })
      }

      this.$nextTick(() => {
        this.filtersWatcher = this.$watch('filters', function (newVal, oldVal) {
          let payload = {
            search: this.search,
          }
          if (!this.hasExternalStatus){
            payload = {
              ...payload,
              statuses: this.filters,
            }
          }
          this.$emit('filter', payload)
        })
      });
    },
    methods: {
      ...statusGetters,
      ...userMethods,
      doesUserHavePermission,
      async loadStatuses () {
        if (typeof this.getStatuses !== 'function') {
          return
        }
        const { data } = await this.getStatuses()
        data.forEach(el => el.selected = false)
        await this.splitStatuses(data)
      },
      tryToSearch () {
        let payload = {
          search: this.search,
          page: 1,
        }
        if (!this.hasExternalStatus){
          payload = {
            ...payload,
            statuses: this.filters,
          }
        }
        this.$emit('filter', payload)
      },

      async splitStatuses(data){
        let basicStatuses = [...data]
        basicStatuses = basicStatuses.filter( el => (
          this.getAdminStatuses().findIndex(element => (el.key === element)) === -1
        )
        )
        this.statuses = basicStatuses

        let adminStatuses = [...data]
        adminStatuses = adminStatuses.filter( el => (
          this.getAdminStatuses().findIndex(element => (el.key === element)) !== -1
        )
        )
        this.statusesAdmin = adminStatuses
      },
      toggleFiltersVar(){
        this.$set(this, 'toggleFilters', !this.toggleFilters)
        this.$emit('toggle-filters', this.displayFilters)
      }
    },
  }
</script>

<template>
  <div
    class="tw-flex"
    :class="{
      'tw-flex-col ': !insideModal,
      'tw-flex-row lg:tw-flex-col ': insideModal,
    }"
  >
    <div
      class="tw-w-full block-item search-box"
      :class="{
        '!tw-border-b-0 lg:!tw-border-b': !hasExtraFilters,
        'tw-border-b': hasExtraFilters && !displayFilters,
        '!tw-border-b-0': hasExtraFilters && displayFilters,
      }">
      <form @submit.prevent="tryToSearch">
        <FabricSectionGroup class="input-group search-box-wrap">
          <input
            v-model="search"
            type="text"
            class="form-control border-0"
            :placeholder="searchPlaceholder"/>
          <template slot="append">
            <div class="search-button-wrap border-0">
              <button
                type="button"
                class="btn-outline-secondary btn-search rounded-circle fl-al-center"
                @click="tryToSearch"
              >
                <SearchIcon size="1.5x" />
              </button>
            </div>
          </template>
        </FabricSectionGroup>
      </form>
    </div>
    <div
      v-if="insideModal && hasExtraFilters"
      class="
        tw-justify-center tw-items-center
        tw-flex lg:tw-hidden
        tw-pr-3 tw-py-2
        tw-border-solid border-col-default-2
        tw-text-positive
        tw-cursor-pointer"
      :class="{
        'tw-border-b': !displayFilters,
        '!tw-border-b-0': displayFilters,
      }"
      @click="toggleFiltersVar">
      <BaseChevronRotate
        v-fabric-collapse.accordion-wrapper-status
        transition-class="rotate-360-270"
        double
        :toggle="displayFilters"
        :duration="500"
      />
    </div>

    <div v-if="statuses.length && !hasExternalStatus" class="block-item bg-white">
      <FabricCollapse
        id="accordion-wrapper-status"
        hide-header
        :duration="500"
        :default-shown="boundCollapse">
        <div class="block-heading">
          <h3
            v-fabric-collapse.accordion-status
            class="
              tw-flex tw-items-center
              tw-text-positive
              tw-leading-relaxed tw-font-medium tw-text-base">
            <a class="tw-no-underline" href="javascript:">Filter by status</a>
            <BaseChevronRotate
              transition-class="rotate-360-270"
              :toggle="!boundCollapse"
              :duration="500"
            />
          </h3>
          <FabricBadge
            :styling-bg="filters.length ? 'badge-primary' : 'badge-light'"
            :copy="filters.length"
          />
        </div>
        <FabricCollapse
          id="accordion-status"
          v-model="boundCollapse"
          hide-header
          :duration="500"
          :default-shown="boundCollapse">
          <div class="block-content">
            <FabricCheckbox
              v-for="statusItem of statuses"
              :key="statusItem.key"
              v-model="statusItem.selected"
              slot-classes="tw-pl-3 tw-text-black"
            >{{ statusItem.name }}</FabricCheckbox>
            <section
              v-if="doesUserHavePermission( getUserPermissions(), adminPermission, getUserType() )">
              <FabricCheckbox
                v-for="statusItem of statusesAdmin"
                :key="statusItem.key"
                v-model="statusItem.selected"
                slot-classes="tw-pl-3 tw-text-black"
              >{{ statusItem.name }}</FabricCheckbox>
            </section>
          </div>
        </FabricCollapse>
      </FabricCollapse>
    </div>
  </div>
</template>
